/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExecRiskForm990SchAType3SprtOrgAll
 */
export interface ExecRiskForm990SchAType3SprtOrgAll {
    /**
     * 
     * @type {string}
     * @memberof ExecRiskForm990SchAType3SprtOrgAll
     */
    timely_provided_documents_ind?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskForm990SchAType3SprtOrgAll
     */
    officers_close_relationship_ind?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskForm990SchAType3SprtOrgAll
     */
    supported_org_voice_investment_ind?: string;
}

/**
 * Check if a given object implements the ExecRiskForm990SchAType3SprtOrgAll interface.
 */
export function instanceOfExecRiskForm990SchAType3SprtOrgAll(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ExecRiskForm990SchAType3SprtOrgAllFromJSON(json: any): ExecRiskForm990SchAType3SprtOrgAll {
    return ExecRiskForm990SchAType3SprtOrgAllFromJSONTyped(json, false);
}

export function ExecRiskForm990SchAType3SprtOrgAllFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecRiskForm990SchAType3SprtOrgAll {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'timely_provided_documents_ind': !exists(json, 'timely_provided_documents_ind') ? undefined : json['timely_provided_documents_ind'],
        'officers_close_relationship_ind': !exists(json, 'officers_close_relationship_ind') ? undefined : json['officers_close_relationship_ind'],
        'supported_org_voice_investment_ind': !exists(json, 'supported_org_voice_investment_ind') ? undefined : json['supported_org_voice_investment_ind'],
    };
}

export function ExecRiskForm990SchAType3SprtOrgAllToJSON(value?: ExecRiskForm990SchAType3SprtOrgAll | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'timely_provided_documents_ind': value.timely_provided_documents_ind,
        'officers_close_relationship_ind': value.officers_close_relationship_ind,
        'supported_org_voice_investment_ind': value.supported_org_voice_investment_ind,
    };
}

